/**
 * Safely decodes the payload of a JWT (base64url → JSON).
 * Does NOT verify the signature — client-side decode only.
 * Returns the decoded payload object, or null if the token is missing/malformed.
 */
export function decodeJwtPayload(token) {
    if (!token || typeof token !== 'string') return null;
    try {
        const parts = token.split('.');
        if (parts.length < 2) return null;
        // Base64url → base64: replace URL-safe chars, restore padding
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
        return JSON.parse(atob(padded));
    } catch {
        return null;
    }
}

/**
 * Returns true if the token is expired, missing, or malformed.
 * Uses client-side decode only — no signature verification.
 */
export function isTokenExpired(token) {
    const payload = decodeJwtPayload(token);
    if (!payload || typeof payload.exp !== 'number') return true;
    return payload.exp < Date.now() / 1000;
}
